import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { colors } from "../../common/colors";
import LoadingModal from "../LoadingModal";
import IconButtonArrow from "./IconButtonArrow";
import { getRole, isGroupLeader, isOver18YearsOld } from "../../util/utils";
import GroupIconImage from "../GreenCity/GroupIconImage";
import appServices from "../../services/app-services/appServices";

interface Props {
  onNext: (group: any) => void;
}

function SeclectGroup({ onNext }: Props): ReactElement {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { user } = useSelector((state: any) => state.userAuth);

  const [groups, setGroups] = useState<any>([]);
  const [selectedGroup, setSelectedGroup] = useState<any>();

  useEffect(() => {
    apiCalls();
  }, []);

  const apiCalls = async () => {
    setIsLoading(true);
    try {
      const params = {status: 'approved'}
      const mygroups = await appServices.getMemberGroups(params);

      setGroups(mygroups.member_groups);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const handleSubmit = () => {
    onNext(selectedGroup);
  };

  const handleGroup = (group: any) => {
    if (!isOver18YearsOld(group.owner.dob)) return

    setSelectedGroup(group);
  };

  return (
    <div style={{ height: 300, width: "100%" }}>
      <Box display="flex" flexDirection="column" sx={{ height: 270, width: "100%", overflow: "scroll" }}>
        {groups?.map((group: any, index: number) => (
          <IconButtonArrow
            // 18歳未満ユーザーが作成したグループへはお金のやり取りはできない
            disabled={!isOver18YearsOld(group.owner.dob)}
            borderColor={group.id === selectedGroup?.id ? colors.farm_green150 : colors.farm_gray100}
            key={index} // Use a unique key in a real app
            icon={<GroupIconImage groupId={group?.id} alt="" style={{ borderRadius: 13, height: 26, width: 26 }} />}
            title={group?.name || ""} // Title from the group
            role={isGroupLeader(group, user) ? getRole("leader") : group?.role === null ? getRole("member") : getRole(group?.role)} // Title from the group
            onClick={() => {
              handleGroup(group);
            }}
          />
        ))}
      </Box>

      <Button
        // disabled={!agree}
        color="secondary"
        sx={styles.submitButton}
        size={"large"}
        variant="outlined"
        onClick={handleSubmit}
        endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, right: 0, margin: "10px" }} icon={faChevronRight} />}
      >
        {T("next")}
      </Button>
      <LoadingModal visible={isLoading} />
    </div>
  );
}
const styles = {
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
    marginBottom: 8,
  },
};

export default SeclectGroup;
